import LoggerService from '../services/LoggerService';

interface I_VARS {
  [key:string]: string
}

/**
 * Lit une variable d'environnement,
 * soit embarquée lors du build via un fichier .env,
 * soit chargée via un fetch sur le serveur
 *
 * @param param0 ex : REACT_APP_API_URL
 */
export const getEnvVariables = async ({names}:{names:string[]}):Promise<I_VARS|undefined> => {
  const logger = LoggerService.getInstance();

  // embarquees au build (valeurs par defaut)
  const vars:any = {};
  names.forEach(n => {
    const embededValue = process.env[n];
    vars[n] = embededValue;
  })

  // fetch sur le serveur courant
  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch('/config.json',params);
  const configServer = await response.json();
  names.forEach(n => {
    const serverValue = configServer[n];
    if (serverValue !== undefined && serverValue !== '') {
      vars[n] = serverValue;
    }
  })

  logger.debug({names,vars,env:process.env.REACT_APP_ENV});

  return vars;
}
